import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { ScrollDirectionEnum } from '../types/enums/scroll-direction.enum';

const SCROLL_TRESHOLD = 25;
@Directive({
  selector: '[appScroll]',
})
export class ScrollDirective {
  @Output() scrolled = new EventEmitter<ScrollDirectionEnum>();
  constructor() {
    document.body.addEventListener('scroll', (event) => {
      console.log('wheel', event);
    });
  }
  @HostListener('scroll', ['$event'])
  scrollHandler($event: Event) {
    console.log('scroll', $event);
  }

  @HostListener('window:scroll', ['$event'])
  windowScrollHandler($event: Event) {
    console.log('window scroll', $event);
  }

  @HostListener('mousewheel', ['$event'])
  mouseWheelHandler($event: WheelEvent) {
    const scrollDirection = $event.deltaY;
    if (Math.abs(scrollDirection) > SCROLL_TRESHOLD) {
      this.scrolled.emit(
        scrollDirection > 0 ? ScrollDirectionEnum.Down : ScrollDirectionEnum.Up
      );
    }
  }
}
